module.exports = __webpack_public_path__ + "img/quem-somos.929b8802.png";